import { createSelector } from 'reselect'
import { isVisualizerSmallerThanLargeDevice } from 'redux/visualizer/selectors'

export const isMinimapEnabled = (state) => !! state.minimap.isEnabled

export const isMinimapDisplayed = createSelector(
    isMinimapEnabled,
    isVisualizerSmallerThanLargeDevice,
    (isMinimapEnabled, isVisualizerSmallerThanLargeDevice) => isMinimapEnabled === true && isVisualizerSmallerThanLargeDevice === false
)

export const minimapButtonTitle = createSelector(
    isMinimapDisplayed,
    isMinimapDisplayed => isMinimapDisplayed ? 'visualizer:toolbar.bottom.filters.minimap.button.disable' : 'visualizer:toolbar.bottom.filters.minimap.button.enable'
)
